import type { LinkProps } from 'react-router-dom'
import type { BoxProps, TypographyProps } from '@mui/material'

class SidebarStyle {
  static Container: BoxProps = {
    position: 'fixed',
    display: 'flex',
    left: 0,
    height: '100%',
    minHeight: '100vh',
    paddingTop: '12rem',
    zIndex: 1201,
    sx: {
      borderRightWidth: 1,
      borderRightStyle: 'solid',
      borderRightColor: 'divider',
      backgroundColor: 'white'
    }
  }

  static Wrapper: BoxProps = {
    display: 'flex',
    minWidth: '10rem',
    padding: 2,
    gap: 3,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    maxHeight: 'calc(100vh - 12rem)',
    sx: {
      overflowY: 'auto', // Enable vertical scrolling
      // '&::-webkit-scrollbar': {
      //   width: '8px', // Width of the scrollbar
      // },
      // '&::-webkit-scrollbar-track': {
      //   background: '#f1f1f1', // Background of the scrollbar track
      // },
      // '&::-webkit-scrollbar-thumb': {
      //   background: '#888', // Color of the scrollbar thumb
      //   borderRadius: '4px', // Rounded corners for the scrollbar thumb
      // },
      // '&::-webkit-scrollbar-thumb:hover': {
      //   background: '#555', // Color of the scrollbar thumb on hover
      // },
    }
  }

  static Button: BoxProps = {
    display: 'flex',
    alignItems: 'center',
    sx: {
      cursor: 'pointer'
    }
  }

  static Icon: BoxProps = {
    display: 'flex',
    marginX: 1.2,
    alignItems: 'center'
  }

  static Title: TypographyProps = {
    fontSize: 14,
    marginRight: 2,
    whiteSpace: 'nowrap'
  }

  static Link: LinkProps = {
    to: '',
    style: {
      color: 'inherit',
      textDecoration: 'none'
    }
  }
}

export default SidebarStyle
